import(/* webpackMode: "eager", webpackExports: ["FundsContainer"] */ "/vercel/path0/apps/portals/src/app/[portalSlug]/(main)/funds/container.tsx");
